export default __webpack_public_path__ + "static/media/mobile_banner_employee.06b099ed.jpg";